import Image from "next/image";
import { Row, Col } from "react-bootstrap";

import { LocalizedLink } from "../localized-link";
import { LanguageProps } from "@/i18n";
import { getStrapiMediaSafe } from "@/lib/strapi/media";
import { GetType } from "@/types/types";

type Microblog = GetType<"api::microblog.microblog">;

interface Props extends LanguageProps {
  article: Microblog;
}

export function ArticleHeaderCard({ article, lang }: Props) {
  return (
    <div>
      <LocalizedLink
        className="link-hover d-block h-100"
        href={`/article/${article.id}`}
        lang={lang}
      >
        <Row className="news-news-card big-image-card">
          <Col className="p-0">
            <Image
              width={0}
              height={0}
              sizes="100vh"
              src={getStrapiMediaSafe(
                article.cover_thumbnail?.data
                  ? article.cover_thumbnail
                  : article.cover,
              )}
              alt={article.headline}
              style={{
                width: "100%",
                height: "100%",
                backgroundSize: "cover",
                padding: 0,
              }}
            />
          </Col>

          <Col className="d-flex align-items-center p-4">
            <div>
              <span className="small">
                {(article.categories?.data ?? [])
                  .map((x) => x.attributes.categorie_name)
                  .join(", ")
                  .toUpperCase()}
              </span>

              <h4 className="mt-0 mb-2">{article.headline}</h4>

              <span className="small pt-2" suppressHydrationWarning>
                {new Date(article.publish_date).toLocaleString("de-DE", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                })}
              </span>
              <p className="pt-2 mb-2 pe-lg-4">{article.summary}</p>
            </div>
          </Col>
        </Row>

        <Row className="news-news-card small-image-card">
          <Col>
            <Row className="d-flex align-content-center justify-content-center flex-row">
              <div className="w-50 p-0">
                <Image
                  width={0}
                  height={0}
                  sizes="100vh"
                  src={getStrapiMediaSafe(
                    article.cover_thumbnail?.data
                      ? article.cover_thumbnail
                      : article.cover,
                  )}
                  alt={article.headline}
                  style={{
                    width: "100%",
                    height: "auto",
                    backgroundSize: "cover",
                    padding: 0,
                  }}
                />
              </div>

              <Col className="d-flex align-items-start justify-content-center flex-column">
                <span className="small">
                  {(article.categories?.data ?? [])
                    .map((x) => x.attributes.categorie_name)
                    .join(", ")
                    .toUpperCase()}
                </span>

                <h4 className="mt-0 mb-2">{article.headline}</h4>

                <span className="small pt-2" suppressHydrationWarning>
                  {new Date(article.publish_date).toLocaleString("de-DE", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                  })}
                </span>
              </Col>
            </Row>
            <Row className="p-3">
              <p className="pt-2 mb-2">{article.summary}</p>
            </Row>
          </Col>
        </Row>
      </LocalizedLink>
    </div>
  );
}
